import { render, staticRenderFns } from "./PostCreationFormModal.vue?vue&type=template&id=5964c155&scoped=true"
import script from "./PostCreationFormModal.vue?vue&type=script&lang=js"
export * from "./PostCreationFormModal.vue?vue&type=script&lang=js"
import style0 from "./PostCreationFormModal.vue?vue&type=style&index=0&id=5964c155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5964c155",
  null
  
)

export default component.exports